import { ITask } from 'interfaces/redux/ITasks';

class ReduxFormUtil {
  static getFieldNamePerTask = <T>(fieldName: keyof T, task: ITask): string => {
    return `${String(fieldName)}.${task.id}`;
  };
}

export { ReduxFormUtil };
